<template>
  <div class="lm-container">
    <div class="lm-headline">
      <div>{{ $t('Webportal.CX.Dashboard.Month') }}</div>
      <div>VIN</div>
      <div>{{ $t('Webportal.CX.OrderType') }}</div>
      <div>{{ $t('Webportal.Status') }}</div>
      <div>{{ $t('Webportal.CX.ModelDescription') }}</div>
      <div>{{ $t('Webportal.CX.ModelYear') }}</div>
    </div>

    <div class="lm-line" v-for="(val, index) in detailItems" :key="index">
      <div>{{ getMonthText(val.HandOver) }}</div>
      <div>{{ val.Vin }}</div>
      <div>{{ val.OrderType }}</div>
      <div :style="{ 'background-color': getStatusColor(val.Status) }">{{ getStatus(val.Status) }}</div>
      <div>{{ val.ModelDescription }}</div>
      <div>{{ val.ModelYear }}</div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    brand:              { type: String, required: true },
    card:               { type: Object, default: undefined },
    detailItems:        { type: Array, default: undefined },
    thresholds:         { type: Array, required: true }
  },

  methods: {
    getMonthText(date) {
      return moment(date).format('DD.MM.yy');
    },

    getStatus(status) {
      return status.replace('JLR_', '');
    },
    
    getStatusColor(status) {
      if (status === 'JLR_PROVISIONED_MODE')
        return this.thresholds[2].Color;
      else if (status === 'JLR_ACTIVE_LEGISLATED_MODE')
        return this.thresholds[1].Color;
        // return 'yellow';
      else 
        return this.thresholds[0].Color;
        // return 'red';
    }
  }
}
</script>

<style lang="scss" scoped>
  .lm-line, .lm-headline {
    grid-template-columns: 2fr 3fr 3fr 3fr 4fr 2fr;
  }
</style>